import axios from "axios";
import { API_BASE_URL, API_STORE_URL, API_TWITCH_URL } from "configs/AppConfig";
import { requestErrorHandler, requestHandler } from "./interceptors/request/requestHandlers";
import { responseErrorHandler, responseSuccessHandler } from "./interceptors/response/responseHandlers";

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
});

export const storeService = axios.create({
  baseURL: API_STORE_URL,
  timeout: 60000,
});

export const twitchService = axios.create({
  baseURL: API_TWITCH_URL,
  timeout: 60000
});

const instances = [service, storeService, twitchService];

// Caso novos interceptors sejam criados, adicionar aqui. Eles serão aplicados em todas as instâncias dentro do "instances"
instances.forEach((instance) => {
  instance.interceptors.request.use(requestHandler, requestErrorHandler);
  instance.interceptors.response.use(
    responseSuccessHandler,
    // A instância é passada para permitir retentativa automática de GETs
    // com falha transitória (ver responseErrorHandler).
    (error) => responseErrorHandler(error, instance)
  );
});

export default service;
